// extracted by mini-css-extract-plugin
module.exports = {"input":"LoginForm_input__NiSyz","button":"LoginForm_button__f0RpN","loginFormWrapper":"LoginForm_loginFormWrapper___ALxD","form":"LoginForm_form__RPbO8"};